/* @flow */
import React from 'react';
import BoxBody from 'components/BoxBody.jsx';
import DialogContent from 'components/DialogContent.jsx';
import Form from 'components/Form.jsx';
import FormInput from 'components/FormInput.jsx';
import UserActions from 'user/UserActions';
import Button from 'components/Button.jsx';
import RecipientParser from 'lib/RecipientParser';
import CurrentUser from 'auth/CurrentUser';

class JoinInfoPageParentEmail extends React.Component {
  props: {
    onDone: Function,
    onError: Function,
  }

  state: {
    canSubmit: boolean,
  }

  state = {
    canSubmit: false,
  }

  disableButton = () => {
    this.setState({ canSubmit: false });
  }

  enableButton = () => {
    this.setState({ canSubmit: true });
  }

  shouldDirectAdd() {
    return CurrentUser.inExpVariant('COPPA_DIRECT_ADD', 'parent_coppa');
  }

  submit = (attrs: Object) => {
    if (this.shouldDirectAdd()) {
      const token = RecipientParser.newToken(attrs.address);
      UserActions
        .addParent(attrs.full_name, token.address)
        .then(this.props.onDone, this.props.onError);
    } else {
      UserActions
        .update({ parent_email: attrs.email })
        .then(this.props.onDone, this.props.onError);
    }
  }

  renderParentAddressInput() {
    return (
      <FormInput
        label="Contact information"
        type="text"
        name="address"
        placeholder="Phone number or email address"
        validations="isEmailOrPhone"
        validationError="Invalid phone or email"
        showErrorAfterBlur
      />
    );
  }

  renderParentEmailInput() {
    return (
      <FormInput
        label="Parent’s email address"
        type="email"
        name="email"
        placeholder="Parent’s email address"
        validations="isEmail"
        validationError="Invalid email"
        showErrorAfterBlur
      />
    );
  }

  render() {
    const shouldDirectAdd = this.shouldDirectAdd();
    let title;
    let subtext;

    if (shouldDirectAdd) {
      title = 'Enter your parent’s name and contact information';
      subtext = 'They’ll be added to Remind and get the same messages you do.';
    } else {
      title = 'Enter your parent’s email';
      subtext = 'Looks like you’re under 13. We’ll send an email to your parent to keep everyone in the loop.';
    }

    return (
      <DialogContent
        size="small"
        full
        className="JoinInfoPageParentEmail"
        title={title}
        subtext={subtext}>
        <BoxBody divided>
          <Form
            onValid={this.enableButton}
            onInvalid={this.disableButton}
            onValidSubmit={this.submit}>
            {
              shouldDirectAdd &&
                <FormInput
                  label="Parent’s full name"
                  required
                  name="full_name"
                  showErrorOnPristine={false}
                  placeholder="First and last name"
                  validations={{ maxLength: 255 }}
                  validationErrors={{
                    maxLength: 'Name should be shorter than 255 characters.',
                  }}
                />
            }
            {shouldDirectAdd ? this.renderParentAddressInput() : this.renderParentEmailInput()}
            <Button
              disabled={!this.state.canSubmit}
              type="submit">
              Done
            </Button>
          </Form>
        </BoxBody>
      </DialogContent>
    );
  }
}

export default JoinInfoPageParentEmail;



// WEBPACK FOOTER //
// ./src/join/components/JoinInfoPageParentEmail.jsx